export const EncIdLength = 16;
export const OtpIdLength = 16;